import { FC } from 'react';
import DropdownClickableItem from 'src/components/Dropdown/DropdownClickableItem';
import DropdownItem from '../Dropdown/DropdownItem';
import { TPromptSettingsDropdownItemName } from './types';
import { usePromptHeaderAnalytics } from './hooks/usePromptHeaderAnalytics';

export type TPromptHeaderDropdownMenu = {
  canEdit: boolean;
  canDelete: boolean;
  handleDelete: () => void;
  handleEdit: () => void;
  onItemClick?: (itemName: TPromptSettingsDropdownItemName) => void;
};

export const PromptHeaderDropdownMenu: FC<TPromptHeaderDropdownMenu> = ({
  canEdit,
  canDelete,
  handleDelete,
  handleEdit,
}) => {
  const analytics = usePromptHeaderAnalytics();
  const buttons = [
    {
      name: 'edit' as TPromptSettingsDropdownItemName,
      text: 'Edit prompt',
      onClick: handleEdit,
      icon: <div className="before:content-editPencil" />,
      shouldDisplay: canEdit,
    },
    {
      name: 'delete' as TPromptSettingsDropdownItemName,
      text: 'Delete prompt',
      onClick: handleDelete,
      icon: <div className="before:content-bin" />,
      shouldDisplay: canDelete,
    },
  ];

  return (
    <>
      {buttons
        .filter((button) => button.shouldDisplay)
        .map(({ onClick, text, icon, name }) => {
          const onClickWithAnalytics = () => {
            analytics.sendPromptSettingsDropdownItemClickEvent(name);
            onClick();
          };
          return (
            <DropdownItem key={name}>
              <DropdownClickableItem leftAdornment={icon} onClick={onClickWithAnalytics}>
                {text}
              </DropdownClickableItem>
            </DropdownItem>
          );
        })}
    </>
  );
};
